import SVG from "../SVG";
import ButtonLoader from "../AsyncState/ButtonLoader";
import { useState } from "react";
export default function Custom({
  text,
  svg_name = "",
  svgClassName = "",
  href = "",
  className = "",
  textShadow = "",
  svgShadow = "",
  onClick = () => {
    return;
  },
  loading = false,
  loadingLabel = "در حال انجام",
  disabled = false,
  type = "button",
}) {
  const [internalLoading, setInternalLoading] = useState(false);
  const pending = loading || internalLoading;
  const handleClick = async (event) => {
    if (disabled || pending) { event?.preventDefault?.(); return; }
    const result = onClick(event);
    if (result && typeof result.then === "function") {
      setInternalLoading(true);
      try { await result; } finally { setInternalLoading(false); }
    }
  };
  if (href === "") {
    return (
      <button
        type={type}
        disabled={disabled || pending}
        aria-busy={pending}
        className={`rounded-xl flex items-center justify-center gap-2.5 py-3 outline-none text-sm ${className}`}
        onClick={handleClick}
      >
        {!pending && <SVG
          name={svg_name}
          classname={`${svgClassName} ${svgShadow ? "drop-shadow-md" : ""}`}
        />}
        {pending ? <ButtonLoader label={loadingLabel} /> : textShadow ? <span className="drop-shadow-md">{text}</span> : <span>{text}</span>}
      </button>
    );
  }
  return (
    <a
      href={href}
      onClick={handleClick}
      className={`rounded-xl flex items-center justify-center gap-2.5 py-3 outline-none text-sm ${className}`}
    >
      {!pending && <SVG
        name={svg_name}
        classname={`${svgClassName} ${svgShadow ? "drop-shadow-md" : ""}`}
      />}
      {pending ? <ButtonLoader label={loadingLabel} /> : textShadow ? <span className="drop-shadow-md">{text}</span> : <span>{text}</span>}
    </a>
  );
}
